<template>
  <div id="ccc">
    <!-- id="downWord" -->
    <div class="tc-report-main" v-for="(item, key) in tableInfoList" :key="key">
      <!-- 普通报告 -->
      <div id="printTest" class="specialReport" v-if="!item.results">
        <div class="specialReportContent">
          <h2>{{ printTitle }}</h2>
          <h2>{{ measure_title }}</h2>
          <div class="hint">
            {{ desc }}
          </div>
          <div class="title" v-show="scope_basic">
            <hr />
            <p>用户基本信息</p>
            <hr />
          </div>
          <div class="userInfo underline" v-show="scope_basic">
            <el-row>
              <el-col :span="8">
                <div>
                  <span>门诊号/住院号:</span>
                  <em>{{ item.customer.account }}</em>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <span>用户姓名:</span>
                  <em>{{ item.customer.name }}</em>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <span>用户性别:</span>
                  <em>{{ item.customer.sex }}</em>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div>
                  <span>用户年龄:</span>
                  <em>{{ item.customer.ages }}岁</em>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <span>出生日期:</span>
                  <em>{{ item.customer.birthday }}</em>
                </div>
              </el-col>
              <el-col :span="8">
                <div>
                  <span>用户学历:</span>
                  <em>{{ item.customer.culture }}</em>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <div>
                  <span>身份证号:</span>
                  <em>{{ item.customer.idcard }}</em>
                </div>
              </el-col>
              <el-col :span="8" v-if="item.customer.archives.slice(0, 1)[0]">
                <div>
                  <span>{{ item.customer.archives.slice(0, 1)[0].name }}:</span>
                  <em>{{ item.customer.archives.slice(0, 1)[0].value }}</em>
                </div>
              </el-col>
              <el-col :span="8" v-if="item.customer.archives.slice(1, 2)[0]">
                <div>
                  <span>{{ item.customer.archives.slice(1, 2)[0].name }}:</span>
                  <em>{{ item.customer.archives.slice(1, 2)[0].value }}</em>
                </div>
              </el-col>
            </el-row>

            <template v-if="item.customer.archives">
              <el-row v-if="item.customer.archives.slice(2, 5).length > 0">
                <el-col
                  :span="8"
                  v-for="(item2, key) in item.customer.archives.slice(2, 5)"
                  :key="key"
                >
                  <div>
                    <span>{{ item2.name }}:</span>
                    <em>{{ item2.value }}</em>
                  </div>
                </el-col>
              </el-row>
              <el-row v-if="item.customer.archives.slice(5, 8).length > 0">
                <el-col
                  :span="8"
                  v-for="(item2, key) in item.customer.archives.slice(5, 8)"
                  :key="key"
                >
                  <div>
                    <span>{{ item2.name }}:</span>
                    <em>{{ item2.value }}</em>
                  </div>
                </el-col>
              </el-row>
              <el-row v-if="item.customer.archives.slice(8, 11).length > 0">
                <el-col
                  :span="8"
                  v-for="(item2, key) in item.customer.archives.slice(8, 11)"
                  :key="key"
                >
                  <div>
                    <span>{{ item2.name }}:</span>
                    <em>{{ item2.value }}</em>
                  </div>
                </el-col>
              </el-row>
              <el-row v-if="item.customer.archives.slice(11, 14).length > 0">
                <el-col
                  :span="8"
                  v-for="(item2, key) in item.customer.archives.slice(11, 14)"
                  :key="key"
                >
                  <div>
                    <span>{{ item2.name }}:</span>
                    <em>{{ item2.value }}</em>
                  </div>
                </el-col>
              </el-row>
            </template>
          </div>
          <!-- <div class="pageNext" v-show="isgrapth"></div> -->
          <div class="title">
            <hr />
            <p style="text-align: center">结果分析</p>
            <hr />
          </div>
          <!-- 图表 -->
          <div
            v-if="theme == 20 || theme == 21"
            id="echart1"
            v-show="isgrapth"
            style="
              display: flex;
              justify-content: center;
              width: 100%%;
              margin: 0 auto;
              box-sizing: border-box;
              height: 120px;
            "
          ></div>
          <div
            v-if="theme != 20 && theme != 21"
            id="echart1"
            v-show="isgrapth"
            style="
              display: flex;
              justify-content: center;
              width: 100%;
              margin: 0 auto;
              box-sizing: border-box;
              height: 300px;
            "
          ></div>
          <div style="width: 861px">
            <el-table
              :header-cell-style="{ background: '#DAF4D7' }"
              :data="
                factor_zp ? item.factor_results.slice(1) : item.factor_results
              "
              style="width: 100%; box-sizing: border-box"
            >
              <el-table-column
                class-name="TableColItem"
                align="center"
                label="项目"
              >
                <template v-slot="scoped">
                  <span v-if="!editState">{{ scoped.row.name }}</span>
                  <span v-else>
                    <el-input
                      placeholder="请输入内容"
                      v-model="scoped.row.name"
                    ></el-input>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                class-name="TableColItem"
                align="center"
                label="程度"
                width="200"
              >
                <template v-slot="scoped">
                  <span v-if="!editState">{{ scoped.row.mark }}</span>
                  <span v-else>
                    <el-input
                      placeholder="请输入内容"
                      v-model="scoped.row.mark"
                    ></el-input>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                class-name="TableColItem"
                align="center"
                label="得分"
              >
                <template v-slot="scoped">
                  <span v-if="!editState">{{ scoped.row.score }}分</span>
                  <span v-else>
                    <el-input
                      placeholder="请输入内容"
                      v-model="scoped.row.score"
                    ></el-input>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div
            v-if="
              Array.isArray(item.base_results)
                ? false
                : item.base_results.comment
            "
            v-show="factor_zp"
            class="divisorExplain"
          >
            <el-row>
              <el-col :span="4">报告总评</el-col>
              <el-col :span="19">
                <p
                  v-show="sitem.comment != ''"
                  v-for="(sitem, index) of [item.base_results]"
                  :key="index"
                >
                  <span v-if="!editState">
                    {{ sitem.comment }}
                  </span>
                  <!-- v-model="item.base_results.comment" -->
                  <span v-else>
                    <el-input
                      type="textarea"
                      :rows="6"
                      placeholder="请输入内容"
                      v-model="sitem.comment"
                    ></el-input>
                  </span>
                </p>
              </el-col>
            </el-row>
          </div>

          <!-- <div
            v-if="report_style * 1 == 1 || report_style * 1 == 0"
            v-show="factor_explain"
            class="divisorExplain"
          >
            <el-row>
              <el-col :span="4">因子说明</el-col>
              <el-col :span="19">
                <p
                  v-show="sitem.comment"
                  v-for="(sitem, index) of factor_zp
                    ? item.factor_results.slice(1)
                    : item.factor_results"
                  :key="index"
                >
                  <span style="color: #ff7633">{{ sitem.name }}</span>
                  <span v-if="!editState">
                    {{ sitem.comment }}
                  </span>
                  <span v-else>
                    <el-input
                      type="textarea"
                      :rows="6"
                      placeholder="请输入内容"
                      v-model="sitem.comment"
                    ></el-input>
                  </span>
                </p>
              </el-col>
            </el-row>
          </div> -->

          <div
            v-if="report_style * 1 == 1 || report_style * 1 == 0"
            v-show="factor_explain"
            class="divisorExplain"
          >
            <el-row
              v-show="sitem.comment"
              v-for="(sitem, index) of factor_zp
                ? item.factor_results.slice(1)
                : item.factor_results"
              :key="index"
            >
              <el-col :span="4" v-show="index == 0 && sitem.comment"
                >因子说明</el-col
              >
              <el-col
                :span="4"
                v-show="index > 0"
                style="background: transparent"
              ></el-col>
              <el-col :span="19">
                <p v-show="sitem.comment">
                  <span style="color: #ff7633">{{ sitem.name }}</span>
                  <span v-html="sitem.comment" v-if="!editState"> </span>
                  <span v-else>
                    <el-input
                      type="textarea"
                      :rows="8"
                      placeholder="请输入内容"
                      v-model="sitem.comment"
                    ></el-input>
                  </span>
                </p>
              </el-col>
            </el-row>
          </div>

          <div
            v-if="report_style * 1 == 2 || report_style * 1 == 0"
            v-show="factor_suggest"
            class="divisorExplain"
          >
            <el-row
              v-show="sitem.advice"
              v-for="(sitem, index) of factor_zp
                ? item.factor_results.slice(1)
                : item.factor_results"
              :key="index"
            >
              <el-col :span="4" v-show="index == 0 && sitem.advice"
                >指导建议</el-col
              >
              <el-col
                :span="4"
                v-show="index > 0"
                style="background: transparent"
              ></el-col>
              <el-col :span="19">
                <p v-show="sitem.advice">
                  <span style="color: #ff7633">{{ sitem.name }}</span>
                  <span v-html="sitem.advice" v-if="!editState"> </span>
                  <span v-else>
                    <el-input
                      type="textarea"
                      :rows="8"
                      placeholder="请输入内容"
                      v-model="sitem.advice"
                    ></el-input>
                  </span>
                </p>
              </el-col>
            </el-row>
          </div>

          <div class="docinfo">
            <div class="signature">
              <span>测评师:</span>
              <img
                v-if="report_sign"
                :src="report_sign"
                alt=""
                width="80"
                height="50"
              />
            </div>

            <div class="rtime">
              <span>报告日期:</span>
              <span>{{ report_time }}</span>
            </div>
          </div>
          <el-row style="margin-top: 20px">
            <el-col style="color: #ff7633; text-align: right">
              本报告仅供参考，请以医生诊断为主。
            </el-col>
          </el-row>
          <div class="pageNext" v-if="answer"></div>
          <div v-if="answer">
            <div>
              <el-table
                :header-cell-style="{ background: '#DAF4D7' }"
                :data="item.question"
                style="width: 100%"
              >
                <el-table-column
                  class-name="TableColItem"
                  align="center"
                  prop="question"
                  label="问题"
                >
                </el-table-column>
                <el-table-column
                  class-name="TableColItem"
                  align="center"
                  label="答案"
                >
                  <template v-slot="scoped">
                    <span v-html="scoped.row.answer + ''"></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <!-- <el-button @click="downWord">下载</el-button> -->
    </div>
  </div>
</template>
<script>
import moment from "moment";
import $ from "jquery";
import jszip from "jszip";
import { selectConfig } from "@/api/comm.js";
export default {
  data() {
    return {
      img: "",
      tableData: [],
      speciChartValue: {},
      report_style: "",
      printTitle: "",
    };
  },
  mounted() {
    let config = JSON.parse(localStorage.getItem("config"));
    this.printTitle = config.unit_name || "重庆谦雅科技有限公司";
    this.initecharts();
  },
  created() {
    selectConfig({ config_type: "system_config,user_config_scope" }).then(
      (res) => {
        this.report_style = res.data.report_style;
      }
    );
  },
  methods: {
    initecharts() {
      setTimeout(() => {
        switch (this.theme) {
          case 20:
            this.RenderEcharts20();
            break;
          case 21:
            this.RenderEcharts21();
            break;
          case 22:
            this.RenderEcharts22();
            break;
          case 23:
            this.RenderEcharts23();
            break;
        }
      }, 300);
    },
    //处理table数据
    changeTable() {
      this.tableInfoList.forEach((v, k) => {
        // -----------------------------------共用报告数据处理------------------------------------------------

        let list1 = [];
        let list3 = [];

        v.factor_results.forEach((vs, ks) => {
          if (vs.graph_show != 0) {
            // -------------数据1，数据2---------------
            if (vs.score != "-") {
              //  ------------最大值和x坐标标记---------------
              let xArr = {};
              xArr["name"] = vs.name;
              xArr["max"] = vs.score * 1 + 0.5;
              // thisArr[ks] = xArr;
              list1.push(vs.score);
              list3.push(vs.name);
            }
          }
          // ------------------图示----------------------
        });
        // resArr[k] = thisArr;

        let data1 = list1;
        let data3 = list3;
        let dataMax = Math.max(...data1.map(Number));
        this.speciChartValue = { data1, data3, dataMax, range: [] };
        // 最大值
        if (v.hasOwnProperty("reference_range")) {
          if (this.theme == 20 && v.reference_range.length > 0) {
            dataMax = v.reference * 1;
            this.speciChartValue.range = v.reference_range;
          }
        }

        // reference中取最大值
        if (v.reference * 1 > dataMax) {
          dataMax = v.reference * 1;
        }
        this.speciChartValue.dataMax = dataMax;
        this.initecharts();
      });
    },
    // 导出word
    // downWord() {
    //   setTimeout(() => {
    //     this.img = document.querySelector("canvas").toDataURL("image/png");
    //     let isTmp = true; // 关闭弹出会触发 catch。    控制 是否到导出完整测评报告   默认允许导出
    //     this.$nextTick(() => {
    //       let num = 0;
    //       $(".pageNext").html(
    //         '<br clear=all style="page-break-before:always" mce_style="page-break-before:always">'
    //       );
    //       // ========================================================================
    //       if (num > 1) {
    //         this.$confirm("每份报告是否需要独立导出？", "提示", {
    //           confirmButtonText: "是",
    //           cancelButtonText: "否",
    //           type: "warning",
    //         })
    //           .then(() => {
    //             isTmp = false; // 禁止关闭触发 导出
    //             // 单个文件-批量导出
    //             this.downLoad = true;
    //             let wordZip = new Promise((resolve, reject) => {
    //               let zip = new jszip();
    //               let title = "这是标题";
    //               let name = "这是名字";
    //               setTimeout(() => {
    //                 let bolo = $(`#downWord`).wordExport("null");
    //                 zip.file(`${name}-${title}.doc`, bolo);
    //                 this.zipData = wordZip;
    //                 resolve(zip);
    //               }, 200 * 1);
    //             });
    //             wordZip.then((res) => {
    //               res.generateAsync({ type: "blob" }).then(function (content) {
    //                 var now = moment().format("YYYY-MM-DD HH:mm:ss");
    //                 saveAs(content, `批量导出Word-${now}.zip`);
    //               });
    //             });
    //             // ====================================
    //           })
    //           .catch(() => {
    //             if (isTmp) {
    //               var now = moment().format("YYYY-MM-DD HH:mm:ss");
    //               $(`#downWord`).wordExport(`完整测评报告-${now}`);
    //             }
    //           });
    //       } else {
    //         let title = this.tableInfoList[0].measure_title;
    //         let name = this.tableInfoList[0].customer.name;
    //         $(`#downWord`).wordExport(`${name}-${title}`);
    //         setTimeout(() => {
    //           this.img = "";
    //         }, 300);
    //       }
    //     });
    //   }, 1000);
    // },

    RenderEcharts20() {
      let ColumnEchart = this.$echarts.init(document.querySelector("#echart1"));
      let value = this.speciChartValue.data1[0];

      let newrange = this.speciChartValue.range;
      let range = newrange.map((item, index) => {
        return item[0];
      });

      let range1 = [],
        range2 = [];
      let rangemax = 0,
        rangemin = 0;
      let bs = 0;
      for (let i = 0; i < range.length; i++) {
        range[i] = range[i].slice(1);
        range[i] = range[i].substring(0, range[i].length - 1);

        let temp = range[i].split("-");
        range1.push(temp[0]);
        range2.push(temp[1]);
        if (i == 0) rangemin = temp[0];
        else if (i == range.length - 1) rangemax = temp[1];
      }
      //console.log(range1,range2,rangemax,rangemin)
      if (rangemax < 10) bs = 100;
      else if (rangemax < 50) bs = 10;
      else bs = 1;
      // if (rangemax < 1000) bs = 10;
      // else if (rangemax >= 1000) bs = 100;

      rangemax = parseInt(rangemax * bs);
      rangemin = parseInt(rangemin * bs);
      value *= bs;
      range = [];
      for (let i = rangemin; i <= rangemax; i++) {
        if (i == parseInt(range2[0] * bs)) {
          //range[i]=' '
          range.push(" ");
          range[
            parseInt((range2[0] * bs - range1[0] * bs) / 2 + range1[0] * bs) -
              rangemin
          ] = range1[0] + "-" + range2[0];

          range1.splice(0, 1);
          range2.splice(0, 1);
        } else range.push(""); //range[i]=''
      }

      let option = {
        grid: {
          top: 50,
          left: 50,
          right: 50,
          bottom: 0,
        },
        yAxis: [
          {
            show: false,
          },
          {
            min: -100,
            max: 0,
            show: false,
            data: range,
          },
        ],
        xAxis: [
          {
            show: false,
            max: rangemax,
            min: rangemin,
          },
          {
            axisLine: {
              show: false,
            },

            axisTick: {
              alignWithLabel: false,
              length: 30,
              lineStyle: {
                width: 2,
                color: "#C3F7E8",
              },
              interval: function (i, v) {
                //console.log(i,v)
                if (i == range.length - 1) return false;
                if (v == " " || i == 0) return true;
                return false;
              },
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#40D8A0",
                fontSize: 20,
                rich: {
                  a: {
                    color: "#F0944F",
                    padding: [0, 10],
                    fontSize: 25,
                    fontWeight: "bold",
                  },
                },
              },
            },

            type: "category",
            data: range,
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            barWidth: 50,
            label: {
              show: true,
              position: "bottom",
              fontSize: 20,
              color: "#F0944F",
              formatter: function (p) {
                let jku = "";
                for (let i of newrange) {
                  if (
                    i[0].split("-")[0][0] == "[" &&
                    i[0].split("-")[1][i[0].split("-")[1].length - 1] == "]"
                  ) {
                    if (
                      i[0].split("-")[0].slice(1) * 1 <= value / bs &&
                      value / bs <=
                        i[0]
                          .split("-")[1]
                          .substring(0, i[0].split("-")[1].length - 1) *
                          1
                    ) {
                      jku = i[1];
                    }
                  }

                  if (
                    i[0].split("-")[0][0] == "(" &&
                    i[0].split("-")[1][i[0].split("-")[1].length - 1] == "]"
                  ) {
                    if (
                      i[0].split("-")[0].slice(1) * 1 < value / bs &&
                      value / bs <=
                        i[0]
                          .split("-")[1]
                          .substring(0, i[0].split("-")[1].length - 1) *
                          1
                    ) {
                      jku = i[1];
                    }
                  }

                  if (
                    i[0].split("-")[0][0] == "(" &&
                    i[0].split("-")[1][i[0].split("-")[1].length - 1] == ")"
                  ) {
                    if (
                      i[0].split("-")[0].slice(1) * 1 < value / bs &&
                      value / bs <
                        i[0]
                          .split("-")[1]
                          .substring(0, i[0].split("-")[1].length - 1) *
                          1
                    ) {
                      jku = i[1];
                    }
                  }

                  if (
                    i[0].split("-")[0][0] == "[" &&
                    i[0].split("-")[1][i[0].split("-")[1].length - 1] == ")"
                  ) {
                    if (
                      i[0].split("-")[0].slice(1) * 1 <= value / bs &&
                      value / bs <
                        i[0]
                          .split("-")[1]
                          .substring(0, i[0].split("-")[1].length - 1) *
                          1
                    ) {
                      jku = i[1];
                    }
                  }
                }
                return jku;
              },
            },

            xAxisIndex: 0,
            yAxisIndex: 1,
            barGap: "-100%",
            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    barBorderRadius: 30,
                    color: "#60E3B2",
                  },
                },
              },
            ],
          },
          {
            name: "",
            type: "bar",
            barWidth: 50,
            label: {
              show: true,
              position: "right",
              fontSize: 20,
              color: "#F0944F",
              formatter: function (p) {
                return p.data.value / bs;
              },
            },

            xAxisIndex: 0,
            yAxisIndex: 1,
            barGap: "-100%",
            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    barBorderRadius: 30,
                    color: "#60E3B2",
                  },
                },
              },
            ],
          },
          {
            name: "",
            type: "bar",
            barWidth: 50,

            xAxisIndex: 0,
            yAxisIndex: 1,

            z: 0,
            data: [
              {
                value: rangemax,
                label: {
                  show: true,
                  position: "right",
                  offset: [0, -28],
                  fontSize: 20,
                  color: "#F0944F",
                  formatter: function (p) {
                    return p.data.value / bs;
                  },
                },
                itemStyle: {
                  normal: {
                    barBorderRadius: 30,
                    color: "#E2F0ED",
                  },
                },
              },
              {
                value: rangemin,
                label: {
                  show: true,
                  position: "top",
                  offset: [-10, 0],
                  fontSize: 20,
                  color: "#F0944F",
                  formatter: function (p) {
                    return p.data.value / bs;
                  },
                },
              },
            ],
          },
        ],
      };
      ColumnEchart.setOption(option);
    },
    RenderEcharts21() {
      let ColumnEchart = this.$echarts.init(document.querySelector("#echart1"));
      var xMax = this.speciChartValue.dataMax;
      let value = this.speciChartValue.data1[0];
      var data = [10];
      var kd = [];
      // 刻度使用柱状图模拟，短设置3，长的设置5；构造一个数据
      for (var i = 0, len = xMax; i <= len; i++) {
        if (i > xMax) {
          kd.push("0");
        } else {
          if (i % 5 === 0) {
            kd.push("5");
          } else {
            kd.push("3");
          }
        }
      }
      var option = {
        grid: {
          top: -50,
          left: 50,
          right: 50,
          bottom: 0,
        },
        xAxis: [
          {
            show: false,
            min: 0,
            max: xMax,
          },
          {
            show: false,
            data: [],
            min: 0,
            max: xMax,
          },
        ],
        yAxis: [
          {
            show: false,
            data: [],
          },
          {
            show: false,
            data: [],
          },
          {
            show: false,
            data: [],
          },
          {
            show: false,
            min: -(xMax + 10),
            max: xMax,
          },
        ],
        series: [
          {
            name: " ",
            type: "bar",
            barWidth: 15,
            silent: true,
            label: {
              show: true,
              position: "right",
              backgroundColor: {
                image:
                  "data:image/png;base64,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",
              },
              z: 1111,
              hoverAnimation: false,
              distance: -15,
              offset: [-10, 30],
              textStyle: {
                color: "transparent",
                fontSize: "40",
                width: 50,
              },
            },

            data: [
              {
                value: value,
                itemStyle: {
                  normal: {
                    color: "transparent", //transparent
                  },
                },
              },
            ],
          },
          {
            name: "",
            type: "bar",
            z: 0,
            barWidth: 30,
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "#6CEBC2",
                  },
                  {
                    offset: 0.3,
                    color: "#80F6F9",
                  },
                  {
                    offset: 0.6,
                    color: "#E4A6FF",
                  },

                  {
                    offset: 1,
                    color: "#FF6C82",
                  },
                ]),
              },
            },
            data: data.map(function (d) {
              return xMax;
            }),
          },
          {
            name: "刻度",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 3,
            label: {
              normal: {
                show: true,
                position: "bottom",
                distance: 60,
                //  color: "#35F7FF",
                rich: {
                  a: {
                    color: "#000",
                    fontFamily: "Microsoft YaHei",
                    fontSize: 20,
                  },
                  b: {
                    color: "#FFB735",
                    fontFamily: "Microsoft YaHei",
                    fontSize: 20,
                  },
                },

                formatter: function (params) {
                  if (params.dataIndex == 0 || params.dataIndex == xMax) {
                    return "{a|" + params.dataIndex + "}";
                  } else if (params.dataIndex == value) {
                    return "{b|" + value + "}";
                  } else {
                    return "";
                  }
                },
              },
            },
            data: kd,
            barGap: "10%",
            barWidth: 2,
            itemStyle: {
              normal: {
                color: "#35F7FF",
                barBorderRadius: 10,
              },
            },
            z: 0,
          },
        ],
      };
      ColumnEchart.setOption(option);
    },

    RenderEcharts22() {
      let ColumnEchart = this.$echarts.init(document.querySelector("#echart1"));
      let value = this.speciChartValue.data1[0];
      let xMax = this.speciChartValue.dataMax;
      let xtest = this.speciChartValue.data3[0];

      let option = {
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
        series: [
          {
            type: "pie",
            startAngle: -(value * 1.8),
            endAngle: 0,
            max: 100,
            radius: ["70%", "70%"],
            z: 1111,
            data: [
              {
                name: "",
                value: 0,
                label: {
                  position: "inside",
                  backgroundColor: "#fff",
                  borderRadius: 20,
                  padding: 5,
                  borderWidth: 10,
                  borderColor: "#fff",
                },
              },
            ],
          },
          //耳环1
          {
            type: "pie",
            startAngle: 0,
            endAngle: 180,
            radius: ["100%", "100%"],
            data: [
              {
                name: "",
                value: 0,
                label: {
                  position: "inside",
                  backgroundColor: "#fff",
                  borderRadius: 10,
                  padding: 5,
                  borderWidth: 10,
                  borderColor: "#9AC7BB",
                },
              },
            ],
          },
          //耳环2
          {
            type: "pie",
            startAngle: 180,
            endAngle: 0,
            radius: ["100%", "100%"],
            data: [
              {
                name: "",
                value: 0,
                label: {
                  position: "inside",
                  backgroundColor: "#fff",
                  borderRadius: 10,
                  padding: 5,
                  borderWidth: 10,
                  borderColor: "#9AC7BB",
                },
              },
            ],
          },
          {
            type: "pie",
            startAngle: 180,
            endAngle: 0,
            z: 0,
            clockWise: true,
            radius: ["60%", "0%"],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                },
                labelLine: {
                  show: false,
                },
              },
            },
            hoverAnimation: false,
            data: [
              {
                value: 50,
                itemStyle: {
                  normal: {
                    color: "#FDF1DA",
                    opacity: 0.5,
                  },
                },
              },
              {
                value: 50,
                name: "",
                itemStyle: {
                  normal: {
                    color: "transparent",
                    label: {
                      show: false,
                    },
                    labelLine: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            radius: "100%",
            axisLine: {
              show: true,
              roundCap: true,
              lineStyle: {
                width: 10,
                color: [[1, "#DBEAE7"]],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
          {
            max: xMax,
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            radius: "90%",
            progress: {
              show: true,
              roundCap: true,
              width: 50,
              itemStyle: {
                color: "#7EE5C4",
                shadowColor: "#7EE5C4",
                shadowBlur: 10,
                shadowOffsetX: 2,
                shadowOffsetY: 2,
              },
            },
            axisLine: {
              roundCap: true,
              show: true,
              lineStyle: {
                width: 50,
                // opacity: 0
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              distance: 20,
              length: 50,
              lineStyle: {
                color: "#6EBBFA",
              },
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              width: 20,
              length: 60,
            },

            detail: {
              show: false,
            },
            markPoint: {
              animation: false,
              data: [
                {
                  value: value,
                  label: {
                    offset: [0, 30],
                    color: "#fff",
                    fontSize: 30,
                  },
                  x: "50%",
                  y: "50%",
                  symbol: "circle",
                  symbolSize: 100,
                  itemStyle: {
                    color: "#FDF1DA",
                  },
                },
                {
                  value: xtest,
                  label: {
                    offset: [0, -10],
                    color: "#fff",
                    fontSize: 20,
                  },
                  x: "50%",
                  y: "50%",
                  symbol: "circle",
                  symbolSize: 90,
                  itemStyle: {
                    color: "#FFB931",
                  },
                },
              ],
            },
            data: [
              {
                value: value,
                itemStyle: {
                  color: "#F9931D",
                },
              },
            ],
          },
        ],
      };
      ColumnEchart.setOption(option);
    },

    RenderEcharts23() {
      let ColumnEchart = this.$echarts.init(document.querySelector("#echart1"));
      let xMax = this.speciChartValue.dataMax;
      let data1 = this.speciChartValue.data1;
      let data3 = this.speciChartValue.data3;

      let labeldata = data3;
      let option = {
        grid: {
          top: 0,
          left: 50,
          right: 50,
          bottom: 50,
        },
        tooltip: {
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "transparent",
            },
            label: {
              color: "#fff",
            },
          },
        },

        xAxis: [
          {
            data: labeldata,
            axisLabel: {
              formatter: function (params) {
                if (params) {
                  let newarr = params.split("");
                  return newarr.join("\n");
                }
              },
              inside: true,
              textStyle: {
                fontSize: 20,
                // color: "#9A9DA5",
                color: "#000",
              },
              //   emphasis:{
              //       textStyle:{
              //             color:"#fff",
              //       }

              //     }
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            z: 10,
          },
        ],
        yAxis: [
          {
            max: xMax,
            splitLine: {
              show: true,
              lineStyle: {
                width: 3,
                type: "dashed",
              },
            },
            type: "value",
            axisLabel: {
              show: false,
            },
          },
        ],
        series: [
          {
            roundCap: true,
            name: "直接访问",
            type: "bar",
            itemStyle: {
              // color: "#E2E5EF",
              // color: "#08CA8F",
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0.3, color: "#61ce9f" },
                { offset: 0.7, color: "#08CA8F" },
                { offset: 1, color: "#1FB978" },
              ]),
              barBorderRadius: [10, 10, 15, 0],
            },
            // emphasis: {
            //   itemStyle: {
            //     color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //       { offset: 0, color: "#0ACA8D" },
            //       { offset: 0.7, color: "#0ACA8D" },
            //       { offset: 1, color: "#0ACA8D" },
            //     ]),
            //   },
            // },
            label: {
              show: true,
              position: "bottom",
              fontSize: 20,
            },
            data: data1,
          },
        ],
      };
      ColumnEchart.setOption(option);
    },

    hasadvice(item) {
      // if (item.factor_results[0].hasOwnProperty("advice")) {
      //   return true;
      // } else {
      //   return false;
      // }
      if (item.factor_results[0].name != "总评") {
        return item.factor_results[0].advice;
      } else {
        return item.factor_results[1].advice;
      }
    },
    hascomment(item) {
      // if (item.factor_results[0].hasOwnProperty("comment")) {
      //   return true;
      // } else {
      //   return false;
      // }

      // if (item.factor_results[0].name == "总评") {
      //   if (item.factor_results[0].length > 1&&item.factor_results[0].hasOwnProperty("comment")) {
      //     return item.factor_results[1].comment;
      //   }
      // } else {
      //   return item.factor_results[0].comment;
      // }
      return item.factor_results[0].comment;
    },
  },
  props: {
    temp_factor_results: {
      type: Object,
      default() {
        return {};
      },
    },
    factor_zp: {
      type: Boolean,
      default() {
        return true;
      },
    },
    editState: {
      type: Boolean,
      default() {
        return true;
      },
    },
    scope_basic: {
      type: Boolean,
      default() {
        return true;
      },
    },
    scope_graph: {
      type: Boolean,
      default() {
        return true;
      },
    },
    scope_factor: {
      type: Boolean,
      default() {
        return true;
      },
    },
    scope_score: {
      type: Boolean,
      default() {
        return true;
      },
    },
    answer: {
      type: Boolean,
      default() {
        return true;
      },
    },
    report_time: {
      type: String,
      default() {
        return "";
      },
    },
    report_sign: {
      type: String,
      default() {
        return "";
      },
    },
    factor_results: {
      type: Array,
      default() {
        return [];
      },
    },
    theme: {
      type: Number | String,
      default() {
        return 20;
      },
    },
    tableInfoList: {
      type: Array,
      default() {
        return [];
      },
    },
    isgrapth: {
      type: Boolean,
      default() {
        return true;
      },
    },
    factor_explain: {
      type: Boolean,
      default() {
        return true;
      },
    },
    factor_suggest: {
      type: Boolean,
      default() {
        return true;
      },
    },
    measure_title: {
      type: String,
      default() {
        return "";
      },
    },
    desc: {
      type: String,
      default() {
        return "";
      },
    },
    chartValue: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    chartValue(val) {
      this.speciChartValue = val;
    },
    tableInfoList: {
      handler(newVal, oldVal) {
        this.changeTable();
        console.log("深度监听", newVal, oldVal);
      },
      deep: true,
    },
  },
};
</script>